module.exports = __webpack_public_path__ + "static/media/WEX.3bf55dc7.svg";